import { useTranslation } from 'react-i18next'
import HomeFilter from '../components/HomeFilter'
import AnnouncesEscort from '../components/announces-escort'
import ContactForm from '../components/ContactForm'

export default function Escortpage() {
  const { t } = useTranslation()
  return (
    <>
      <div
        id='premium-slider'
        className='text-center w-full align-middle bg-redpink text-white  py-3'
      >
        <p className='uppercase text-2xl'>{t('escort-corner')}</p>
        <p className=''>{t('escort-corner-desc')}</p>
      </div>
      <div
        id='home-filter'
        className='w-full mx-auto justify-center text-anthracite'
      >
        <HomeFilter />
      </div>
      <div
        id='announces-home'
        className='w-full mx-auto  justify-center text-anthracite'
      >
        <AnnouncesEscort />
      </div>

      <ContactForm />
    </>
  )
}
